"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Evidence = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const react_virtualized_auto_sizer_1 = __importDefault(require("react-virtualized-auto-sizer"));
const split_screen_1 = require("../../components/split-screen/split-screen");
const detail_1 = require("../detail/detail");
const table_1 = require("../table/table");
const evidence_hook_1 = require("./evidence-hook");
const evidence_styles_1 = require("./evidence-styles");
const screen_mode_hook_1 = require("./hook/screen-mode-hook");
const toolbar_hook_1 = require("./hook/toolbar-hook");
const evidence_context_1 = require("../evidence/evidence-context");
function Evidence(props) {
    const { tableProps, detailProps, switcherProps } = props;
    const { columns, FieldsComponent, tableSource, crudSource, hookedSources, splitScreenRef, tableRef, detailRef, handleRowClick, handleActiveRowChange, handleDetailPersisted, detailTitle, tableTitle, defaultTitle, defaultSplitScreenMode, } = evidence_hook_1.useEvidence(props);
    screen_mode_hook_1.useScreenMode({
        splitScreenRef,
        hideMenuTools: switcherProps === null || switcherProps === void 0 ? void 0 : switcherProps.hideMenuTools,
    });
    const { BeforeToolbar } = toolbar_hook_1.useEvidenceTableToolbar({ tableRef });
    const toolbarProps = react_1.useMemo(() => lodash_1.merge({ before: BeforeToolbar }, detailProps === null || detailProps === void 0 ? void 0 : detailProps.toolbarProps), [BeforeToolbar, detailProps === null || detailProps === void 0 ? void 0 : detailProps.toolbarProps]);
    const classes = evidence_styles_1.useStyles();
    return (react_1.default.createElement(evidence_context_1.EvidenceContext.Provider, { value: {
            apiUrl: props.apiProps.url,
            tableSource,
            crudSource,
            hookedSources,
            tableRef,
            detailRef,
            splitScreenRef,
        } },
        react_1.default.createElement("div", { className: classes.evidence, "data-cy": "EAS__EVIDENCE" },
            react_1.default.createElement(react_virtualized_auto_sizer_1.default, { disableWidth: true }, ({ height }) => (react_1.default.createElement("div", { style: { height, display: 'flex' } },
                react_1.default.createElement(split_screen_1.SplitScreen, { ref: splitScreenRef, rightLabel: switcherProps === null || switcherProps === void 0 ? void 0 : switcherProps.rightLabel, leftLabel: switcherProps === null || switcherProps === void 0 ? void 0 : switcherProps.leftLabel, midPoint: 600, rightTitle: detailTitle, leftTitle: tableTitle, defaultTitle: defaultTitle.current, defaultMode: defaultSplitScreenMode },
                    react_1.default.createElement(table_1.Table, Object.assign({ tableId: props.identifier + '_TABLE', version: props.version, ref: tableRef }, tableProps, { columns: columns, source: tableSource, height: height, onRowClick: handleRowClick, onActiveChange: handleActiveRowChange })),
                    react_1.default.createElement(detail_1.Detail, Object.assign({ ref: detailRef }, detailProps, { toolbarProps: toolbarProps, FieldsComponent: FieldsComponent, source: crudSource, onPersisted: handleDetailPersisted })))))))));
}
exports.Evidence = Evidence;
//# sourceMappingURL=evidence.js.map